import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyBhZ8DU19u4bKJt-6ZyqEOLGbYNXqIpKnw",
  authDomain: "porkco-76bf9.firebaseapp.com",
  projectId: "porkco-76bf9",
  storageBucket: "porkco-76bf9.firebasestorage.app",
  messagingSenderId: "946822052852",
  appId: "1:946822052852:web:52340d53014c3ad5f917a1"
};

// Initialize the Firebase app
const app = initializeApp(firebaseConfig);

// Export auth and Firestore so other files can use them
export const auth = getAuth(app);
export const db = getFirestore(app);

export default app;
